<div class="min-h-screen bg-gradient-to-br from-blue-50 via-white to-blue-100 py-3">
  <div class="max-w-7xl mx-auto px-2">

    <!-- ===== DASHBOARD HEADER (CLEANED) ===== -->
    <header class="bg-white shadow-sm rounded mb-3">
      <div class="flex flex-wrap items-center justify-between gap-2 px-3 py-2">
        <!-- Left: Icon + Title + Subtitle -->
        <div class="flex items-center gap-2 min-w-0">
          <span class="bg-blue-100 text-blue-600 rounded p-1 flex items-center justify-center">
            <i class="pi pi-chart-line text-lg"></i>
          </span>

          <div class="flex flex-col sm:flex-row sm:items-center sm:gap-2 min-w-0">
            <span class="font-semibold text-sm text-gray-700 truncate">
              iDEX <span class="opacity-60">&gt;</span> Dashboard
            </span>
            <span class="text-gray-400 text-xs sm:inline-block">
              Real-time Challenge Management &amp; Analytics
            </span>
          </div>
        </div>

        <!-- Right: Button -->
        <button
          class="flex items-center gap-1 bg-blue-600 text-white px-3 py-1 rounded text-xs font-semibold hover:bg-blue-700 transition"
          (click)="navigateto()">
          <i class="pi pi-plus-circle text-base"></i>
          <span class="hidden sm:inline">New Challenge</span>
        </button>
      </div>
    </header>

<!-- OVERALL SUMMARY METRICS -->
<app-summary-metrics
  [totalContracts]="totalContracts"
  [totalProposals]="totalProposals"
  [totalSubSchemes]="totalSubSchemes"
  [totalPreLaunch]="totalPreLaunch"
  [totalForLaunch]="totalForLaunch"
  [totalPostLaunch]="totalPostLaunch"
  [completedProposals]="completedProposals"
  [loading]="dashboardLoading"
  [schemeWiseGrant]="schemeWiseGrant"
  [schemeWiseProposal]="schemeWiseProposal"
  [schemeWisePrelaunch]="schemeWisePrelaunch"
  [schemeWiseForlaunch]="schemeWiseForlaunch"
  [schemeWisePostlaunch]="schemeWisePostlaunch"
  [schemeWiseCompleted]="schemeWiseCompleted"
  [contractSchemesOrder]="['INDUSX','DISC', 'ADITI', 'Prime', 'OC', 'Fauji']"
  [proposalSchemesOrder]="['INDUSX','DISC', 'ADITI', 'Prime', 'OC', 'Fauji']"
  [preLaunchSchemesOrder]="['INDUSX','DISC', 'ADITI', 'Prime', 'OC', 'Fauji']"
  [forLaunchSchemesOrder]="['INDUSX','DISC', 'ADITI', 'Prime', 'OC', 'Fauji']"
  [postLaunchSchemesOrder]="['INDUSX','DISC', 'ADITI', 'Prime', 'OC', 'Fauji']"
  [completedSchemesOrder]="['INDUSX','DISC', 'ADITI', 'Prime', 'OC', 'Fauji']">
</app-summary-metrics>

<!-- GRANT SUMMARY -->
<app-grant-summary
  [totalApproved]="totalGrantsApproved"
  [totalSpent]="totalGrantsSpent"
  [totalPending]="totalGrantsPending"
  [loading]="dashboardLoading"
  [schemeWiseApproved]="schemeWiseApproved"
  [schemeWiseSpent]="schemeWiseSpent"
  [schemeWisePending]="schemeWisePending">
</app-grant-summary>

<!-- STATUS CARDS (COMPACT) -->
<!-- <div class="max-w-7xl mx-auto px-3 mb-4">

 -->
    <!-- Smart filters removed (per requirement) -->



    <!-- MILESTONE TRACKING TABLE -->
    <app-milestone-tracking-table
      [milestoneData]="milestoneData"
      [loading]="dashboardLoading">
    </app-milestone-tracking-table>

<div class="bg-gradient-to-br from-blue-50 via-white to-blue-100 py-3">
  <div class="max-w-7xl mx-auto px-2">

    <!-- Compact Chart Grid -->
    <div id="charts-to-print" class="space-y-5">

      <!-- Proposal Trends -->
        <section class="bg-white rounded-xl shadow p-3">

            <!-- Header -->
            <div class="flex items-center justify-between mb-2 gap-2">

              <div class="flex items-center gap-2">
                <span class="bg-blue-100 text-blue-600 rounded p-1.5">
                  <i class="pi pi-chart-line text-base"></i>
                </span>

                <div>
                  <h3 class="text-base font-bold text-gray-900 leading-tight">
                    Proposal Trends
                  </h3>
                  <p class="text-gray-400 text-xs mt-1">
                    Proposal lifecycle overview
                  </p>
                </div>
              </div>

              <!-- Right Side -->
              <div class="flex items-center gap-2">

                <!-- Year Filter -->
                <div class="flex items-center gap-2">

                  <!-- From Date -->
                  <input type="date" [(ngModel)]="fromDate" (change)="onFilterChange()"
                    class="border border-gray-300 rounded px-2 py-1 text-sm" />

                  <!-- To Date -->
                  <input type="date" [(ngModel)]="toDate" (change)="onFilterChange()"
                    class="border border-gray-300 rounded px-2 py-1 text-sm" />

                </div>

                <!-- Export Button -->
                <button
                  class="bg-white hover:bg-blue-100 text-blue-500 rounded-full px-2 py-1 border border-blue-200 transition"
                  pTooltip="Export Data">
                  <i class="pi pi-download text-base"></i>
                </button>

              </div>
            </div>

            <!-- Chart -->
             <!-- <div class="bg-gradient-to-tr from-blue-50 to-blue-100 rounded-lg p-2 shadow group relative">
            <button
              class="absolute top-2 right-2 bg-white rounded-full shadow p-1 hover:bg-blue-200 transition z-10"
              (click)="openFullscreen('chart1')">
              <i class="pi pi-window-maximize text-base text-blue-500"></i>
            </button>
            <div>
              <p-chart type="bar" [data]="chartData1" [options]="chartOptions"
                       style="min-height:130px;height:130px;max-height:160px"></p-chart>
            </div>
            <h4 class="text-center text-xs font-medium text-gray-700 mt-1">
              Year-wise Proposals vs Completed
            </h4>
          </div> -->
            <div class="bg-gradient-to-tr from-blue-50 to-blue-100 rounded-lg p-2 shadow relative">
            <button
              class="absolute top-2 right-2 bg-white rounded-full shadow p-1 hover:bg-blue-200 transition z-10"
              (click)="openFullscreen('chart1')">
              <i class="pi pi-window-maximize text-base text-blue-500"></i>
            </button>
              <div class="overflow-x-auto">

                <div [style.min-width.px]="chartData1?.labels?.length * 120">
                  <div class="proposal-trends-chart-wrap" [style.height.px]="proposalTrendsChartHeightPx">
                    <p-chart
                      type="bar"
                      [data]="chartData1"
                      [options]="chartOptions"
                      style="height: 100%; width: 100%;">
                    </p-chart>
                  </div>
                </div>

              </div>

              <h4 class="text-center text-xs font-medium text-gray-700 mt-2">
                Year-wise Proposals vs Completed
              </h4>

            </div>

          </section>

      <!-- Fund Utilisation & Value -->
      <section class="bg-white rounded-xl shadow p-3">
        <div class="flex items-center justify-between mb-2 gap-2">
          <div class="flex items-center gap-2">
            <span class="bg-green-100 text-green-600 rounded p-1.5">
              <i class="pi pi-dollar text-base"></i>
            </span>
            <div>
              <h3 class="text-base font-bold text-gray-900 leading-tight">Fund Utilisation &amp; Value</h3>
              <p class="text-gray-400 text-xs leading-none mt-1">Fund trends &amp; distribution</p>
            </div>
          </div>
          <button
            class="bg-white hover:bg-green-100 text-green-500 rounded-full px-2 py-1 border border-green-200 transition"
            pTooltip="Export Data">
            <i class="pi pi-download text-base"></i>
          </button>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
          <!-- Chart 3 -->
          <div class="bg-gradient-to-tr from-green-50 to-green-100 rounded-lg p-2 shadow group relative">
            <button
              class="absolute top-2 right-2 bg-white rounded-full shadow p-1 hover:bg-green-200 transition z-10"
              (click)="openFullscreen('chart3')">
              <i class="pi pi-window-maximize text-base text-green-600"></i>
            </button>
            <div>
              <p-chart type="line" [data]="chartData3" [options]="chartOptions"
                       style="min-height:220px;height:240px;max-height:260px"></p-chart>
            </div>
            <h4 class="text-center text-xs font-medium text-gray-700 mt-1">
              Funds Utilised Year-wise
            </h4>
          </div>

          <!-- Chart 6 -->
          <div class="bg-gradient-to-tr from-violet-50 to-indigo-100 rounded-lg p-2 shadow group relative">
            <button
              class="absolute top-2 right-2 bg-white rounded-full shadow p-1 hover:bg-indigo-200 transition z-10"
              (click)="openFullscreen('chart6')">
              <i class="pi pi-window-maximize text-base text-indigo-600"></i>
            </button>
            <div>
              <p-chart type="bar" [data]="chartData6" [options]="chartOptions"
                       style="min-height:220px;height:240px;max-height:260px"></p-chart>
            </div>
            <h4 class="text-center text-xs font-medium text-gray-700 mt-1">
              Proposal Value vs Disbursed Funds
            </h4>
          </div>
        </div>
      </section>
    </div>

    <!-- Fullscreen Chart Dialog -->
    <p-dialog
      [(visible)]="fullscreenVisible"
      [modal]="true"
      [style]="{width: '95vw'}"
      [contentStyle]="{height: '85vh'}">
      <ng-template pTemplate="header">
        <h5 class="text-base font-bold text-gray-800 m-0">{{ fullscreenChart.title }}</h5>
      </ng-template>
      <div class="h-full flex items-center justify-center">
        <p-chart
          [type]="fullscreenChart.type"
          [data]="fullscreenChart.data"
          [options]="chartOptions">
        </p-chart>
      </div>
    </p-dialog>

  </div>
</div>
